import StatusCell from "./StatusCell";

const ResultsTableRow = ({ row }) => {
  let result;

  // If something goes wrong when fetching a row, display the response error message.
  if (row.statusCode === 404) {
    result = (
      <td className="td color-danger-light">
        {row.message}
      </td>
    )
  } else if (row.copilotId) {
    result = (
      <>
        <td className="td">{row.copilotId}</td>
        <td className="td">
          <StatusCell row={row} />
        </td>
        <td className="td">
          {row.appleShareUrl && <a href={row.appleShareUrl}>{row.appleShareUrl}</a>}
        </td>
      </>
    )
  }
  return (
    <tr className="tr" key={row._id}>
      {result}
    </tr>
  )
}

export default ResultsTableRow;